(() => {
  const SELECTOR = '[data-lfl-product-select]';

  class ProductPremiumSelect {
    constructor(root) {
      if (root.dataset.lflSelectReady === 'true') return;

      this.root = root;
      this.nativeSelect = root.querySelector('select');
      this.trigger = root.querySelector('.lfl-product-select__trigger');
      this.value = root.querySelector('[data-lfl-select-value]');
      this.panel = root.querySelector('.lfl-product-select__panel');
      this.options = Array.from(root.querySelectorAll('[data-lfl-select-option]'));

      if (!this.nativeSelect || !this.trigger || !this.panel || !this.options.length) return;

      root.dataset.lflSelectReady = 'true';
      root.classList.add('is-enhanced');
      this.bindEvents();
      this.syncFromNative();
    }

    bindEvents() {
      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.open();
          this.focusSelectedOption();
        }
      });

      this.options.forEach((option, index) => {
        option.addEventListener('click', () => this.select(option.dataset.value));
        option.addEventListener('keydown', (event) => this.onOptionKeydown(event, index));
      });

      this.nativeSelect.addEventListener('change', () => this.syncFromNative());
      document.addEventListener('click', (event) => {
        if (!this.root.contains(event.target)) this.close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.root.classList.contains('is-open')) {
          this.close();
          this.trigger.focus();
        }
      });
    }

    onOptionKeydown(event, index) {
      let nextIndex = null;
      if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.options.length;
      if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.options.length) % this.options.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.options.length - 1;

      if (nextIndex !== null) {
        event.preventDefault();
        this.options[nextIndex].focus();
      }
    }

    toggle() {
      this.root.classList.contains('is-open') ? this.close() : this.open();
    }

    open() {
      document.querySelectorAll(`${SELECTOR}.is-open`).forEach((select) => {
        if (select !== this.root) {
          select.classList.remove('is-open');
          select.querySelector('.lfl-product-select__trigger')?.setAttribute('aria-expanded', 'false');
          const panel = select.querySelector('.lfl-product-select__panel');
          if (panel) panel.hidden = true;
        }
      });

      this.root.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
    }

    close() {
      this.root.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
    }

    focusSelectedOption() {
      const selected = this.options.find((option) => option.classList.contains('is-selected')) || this.options[0];
      selected.focus();
    }

    select(value) {
      if (!value) return;
      this.nativeSelect.value = value;
      this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncFromNative();
      this.close();
      this.trigger.focus();
    }

    syncFromNative() {
      const selectedValue = this.nativeSelect.value;
      const selectedOption = this.nativeSelect.options[this.nativeSelect.selectedIndex];
      this.value.textContent = selectedOption?.textContent.trim() || selectedValue;

      this.options.forEach((option) => {
        const isSelected = option.dataset.value === selectedValue;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', String(isSelected));
      });
    }
  }

  const initProductSelects = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => new ProductPremiumSelect(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductSelects());
  } else {
    initProductSelects();
  }

  document.addEventListener('shopify:section:load', (event) => initProductSelects(event.target));
})();
